// removed by extract-text-webpack-plugin
module.exports = {"isFaded":"LocationMarker-isFaded--1-qWG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Map/MapComponents/LocationMarker/LocationMarker.scss
// module id = daf4
// module chunks = 4